import * as yup from 'yup';

yup.addMethod(yup.string, 'descontoMaiorValorBase', function (errorMessage) {
    return this.test('test-desconto-maior-valor-base', errorMessage, function (_value) {
        try {
            const { path, createError, parent } = this;
            let temErro = false;
            const { valorBase, valorDesconto, atualizarSomenteValorDesconto } = parent;

            const parseValorBase = Number.parseFloat(valorBase?.replace(',', '.'));
            const parseValorDesconto = Number.parseFloat(
                valorDesconto?.replace(',', '.')
            );

            if (parseValorDesconto > parseValorBase) {
                temErro = true;
            }

            if (atualizarSomenteValorDesconto) {
                temErro = false;
            }

            return !temErro || createError({ path,
                message: errorMessage });
        } catch (error) {
            console.log(error);
        }
    });
});

yup.addMethod(yup.string, 'descontoIgualValorNovo', function (errorMessage) {
    return this.test('test-desconto-igual-valor-novo', errorMessage, function (_value) {
        try {
            const { path, createError, parent } = this;
            let temErro = false;
            const {
                novo,
                descontoValor,
                atualizarSomenteValorDesconto,
                descontoPercentual
            } = parent;

            const parseValorNovo = Number(novo);
            const parseValorDesconto = Number(descontoValor);

            if (parseValorDesconto >= parseValorNovo) {
                temErro = true;
            }

            if (atualizarSomenteValorDesconto) {
                temErro = false;
            }

            if (descontoPercentual) {
                temErro = false;
            }

            return !temErro || createError({ path,
                message: errorMessage });
        } catch (error) {
            console.log(error);
        }
    });
});

yup.addMethod(
    yup.string,
    'peloMenosUmaFormaDePagamentoFoiSelecionada',
    function (errorMessage) {
        return this.test(
            'test-desconto-igual-valor-novo',
            errorMessage,
            function (_value) {
                try {
                    const { path, createError, parent } = this;
                    let temErro = false;
                    const { pagamentoEscelsa, pagamentoCartao, pagamentoBoleto } =
                        parent;

                    if ((!pagamentoBoleto && !pagamentoEscelsa, !pagamentoCartao)) {
                        temErro = true;
                    }

                    return !temErro || createError({ path,
                        message: errorMessage });
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
);

export const adesaoSchema = yup.object().shape({
    atualizarSomenteValorDesconto: yup.boolean(),
    carenciaPromocional: yup
        .string()
        .transform(value => value.trim().replace('dias', ''))
        .when('atualizarSomenteValorDesconto', {
            is: true,
            then: yup
                .string()
                .transform(value => value.trim().replace('dias', '')),
            otherwise: yup.string().transform(value => value.trim().replace('dias', '')).required('Carência promocional é obrigatório')
        }),
    carenciaSemPromocao: yup
        .string()
        .transform(value => value.trim().replace('dias', '')),
    novo: yup.string().transform(value => value.replace(/_|,|R\$/g, '')),
    troca: yup.string().transform(value => value.replace(/_|,|R\$/g, '')),
    reabilitacao: yup.string().transform(value => value.replace(/_|,|R\$/g, '')),
    cremacao: yup.string().transform(value => value.replace(/_|,|R\$/g, '')),
    dataInicioDesconto: yup
        .date()
        .nullable()
        .when('valorDesconto', {
            is: valorDesconto => valorDesconto,
            then: yup.date().required('Preencha uma data para início do desconto.'),
            otherwise: yup.date()
        })
        .when('descontoPercentual', {
            is: descontoPercentual =>
                descontoPercentual !== undefined &&
                descontoPercentual !== null &&
                descontoPercentual,
            then: yup
                .date()
                .required(
                    'Data inicio desconto é obrigatória quando um tipo de desconto for preenchido'
                ),
            otherwise: yup.date()
        })
        .when('descontoValor', {
            is: descontoValor =>
                descontoValor !== undefined && descontoValor !== null && descontoValor,
            then: yup
                .date()
                .required(
                    'Data inicio desconto é obrigatória quando um tipo de desconto for preenchido'
                ),
            otherwise: yup.date()
        }),
    dataFinalDesconto: yup
        .date('insira uma data valida')
        .nullable()
        .min(
            yup.ref('dataInicioDesconto'),
            'A data final de desconto deve ser maior que a data inicial do desconto!'
        )
        .when('dataInicioDesconto', {
            is: dataInicioDesconto =>
                dataInicioDesconto !== undefined &&
                dataInicioDesconto !== null &&
                dataInicioDesconto !== '',
            then: yup
                .date()
                .required(
                    'Caso a data de início esteja informada, data final deve ser preenchida!'
                ),
            otherwise: yup.date()
        }),
    descontoPercentual: yup
        .number()
        .min(0, 'Deve ser um número positivo')
        .max(99, 'O desconto percentual deve ser no maximo 99'),
    descontoValor: yup
        .string()
        .descontoIgualValorNovo(
            'O valor do desconto nao pode ser maior ou igual ao valor novo'
        ),
    pagamentoCartao: yup.boolean(),
    pagamentoBoleto: yup.boolean(),
    pagamentoEscelsa: yup.boolean(),
    formasPagamento: yup.lazy(_ =>
        yup
            .boolean()
            .test(
                'pelo-menos-uma-forma-pagamento',
                'Selecione pelo menos uma forma de pagamento',
                function (_) {
                    try {
                        const {
                            novo,
                            pagamentoCartao,
                            pagamentoBoleto,
                            pagamentoEscelsa,
                            atualizarSomenteValorDesconto
                        } = this.parent;

                        if (novo || atualizarSomenteValorDesconto) {
                            return (
                                pagamentoCartao || pagamentoBoleto || pagamentoEscelsa
                            );
                        }

                        return true;
                    } catch (error) {
                        console.log(error);
                    }
                }
            )
    )
});
